import React, {useEffect, useState} from "react"
import { Route, RouterProvider , createBrowserRouter, createRoutesFromElements } from "react-router-dom"
import WebFont from "webfontloader"
import HomePage from "./components/home_page"
import Products from "./components/products"
import AboutUs from "./components/about_us"
import Support from "./components/support"
import InternalUserProductCreation from "./components/general/internalUser/internal_user_page"
import ProductPage from "./components/general/products/product_page"
import Layout from "./components/functionality/layout"

export default function Main(){
    useEffect(()=>{
        WebFont.load({
            google:{
                families: ['Oswald', 'Material Icons','Montserrat']
            }
        })
    },[])
    const router = createBrowserRouter(
                    createRoutesFromElements(
                        <Route path="/" element={<Layout/>}>
                            <Route index element={<HomePage/>}/>
                            <Route path="products" element={<Products/>}/>
                            <Route path="about-us" element={<AboutUs/>}/>
                            <Route path="support" element={<Support/>}/>
                            <Route path="jfLogin" element={<InternalUserProductCreation/>}/>
                            <Route path="products/:productId" element={<ProductPage/>}/>
                        </Route>
                    )
                )
            
    return(
        <>
            <RouterProvider router={router}/>
        </>
  
     )
}

